<template>
  <div class="line-chart-modal1" ref="lineChartModalRef">

    <artmisads-modal
      :open="true"
      :title="props.title"
      :width="1200"
      :getContainer="() => lineChartModalRef"
      :destroyOnClose="true"
      :maskClosable="false"
      :footer="null"
      :onCancel="props.onCancleModal"
    >
    <div class="sp-head-content" v-if="props.pageType === 'publisherProduct'">
            <span v-if="!props.itemInfo.productImageUrl"></span>
            <img v-else :src="props.itemInfo.productImageUrl" />
            <div class="text">
              <p>{{props.itemInfo.productTitle}}</p>
              <div class="flex">
                <span>{{props.itemInfo.productAsin}}</span>
                
              </div>
            </div>
          </div>
          <div class="brand-head-content" v-else-if="props.pageType === 'publisherBrandLink'">
            <span v-if="!props.itemInfo.brandLogoImageUrl"><em class="brand-name">{{ props.itemInfo.brandName }}</em></span>
            <img v-else :src="props.itemInfo.brandLogoImageUrl" />
            <div class="text">
              <p>{{props.itemInfo.brandName}}</p>
              <p class="biography" v-if="props.itemInfo.biography">{{props.itemInfo.biography}}</p>
            </div>
          </div>
    <div class="filterBar">
      
      <div class="filterBar-content">
       <div class="date">
        <!-- <span>Date Range</span> -->
        <artemisads-range-picker :allowClear="false" :value="hackValue || dateParams" 
          :presets="RANGE_PRESETS" :disabled-date="disabledDate" @change="onChangeDate" @openChange="onOpenChange"
          @calendarChange="onCalendarChange" :getPopupContainer="() => lineChartModalRef"/>
        </div>
       </div>
    </div>
    <a-spin :spinning="props.loading">
    <div class="table">
      <artmisads-table
        :columns="columns"
        row-key="primaryTrackingId"
        :data-source="props.dataList"
        :scroll="{x: 1000}"
        :pagination="{
          total: props.tableTotal,
          current: props.params.page,
          pageSize: props.params.size,
          showSizeChanger: true
        }"
        :change="onChangePage"
        rowClassName="table-item"
        table-layout="fixed"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.name === 'showCurrency'">
            {{text ? AMAZON_CURRENCY_MAPPER[props.marketplace] : ''}}{{text}}
          </template>
          <template v-if="column.name === 'conversionsRate'&&!record.children">
            {{ text ? (text * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1') + '%' : '0' }}
          </template>
        </template>
      </artmisads-table>
    </div>
    </a-spin>

  </artmisads-modal>
  </div>
</template>

<script setup lang="jsx">
import { ref,computed } from 'vue';
import { AMAZON_CURRENCY_MAPPER } from '~/contants/common';
import { RANGE_PRESETS } from '~/contants/reports'
import moment from 'moment'
const props = defineProps({
  pageType: {
    type: String,
    default: ''
  },
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Tracking ID Report'
  },
  dataList: {
    type: Array,
    default: () => []
  },
  marketplace: {
    type: String,
    default: 'amazon.com'
  },
  tableTotal: {
    type: Number,
    default: 0
  },
  params: {
    type: Object,
    default: () => ({})
  },
  setParams: {
    type: Function,
    default: () => {}
  },
  onCancleModal: {
    type: Function,
    default: () => {}
  },
  itemInfo: {
    type: Object,
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  }
});
const dates = ref()
const hackValue = ref()
const disabledDate = current => {
  let notDate = false, tooLate = false, tooEarly = false
  notDate = current.valueOf() > moment().valueOf()
  if (dates.value && dates.value.length) {
    tooEarly = dates.value[1] && dates.value[1].diff(current, 'days') > 365
    tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > 365
  }
  return notDate || tooEarly || tooLate
}

const lineChartModalRef = ref();
const emit = defineEmits(['update:visible', 'cancel']);
const dateParams = ref([moment(props.params.startReportDateTimestamp),moment(props.params.endReportDateTimestamp)])
// const onCancel = () => {
//   emit('update:visible', false);
//   emit('cancel');
// };

const onChangePage = (data, filters, sorter) => {
  const { current, pageSize } = data;
  let newParams = { ...props.params };
  newParams.page = current;
  newParams.size = pageSize;
  if (sorter) {
    const { field, order } = sorter;
    newParams.sortField = field;
    newParams.sortDirection = order === 'ascend' ? 'asc' : 'desc';
  }
  props.setParams(newParams);
};
const onChangeDate=val=>{
  if (val) {
    dateParams.value = val
    const dateTime = {
      startReportDateTimestamp: val[0].valueOf(),
      endReportDateTimestamp: val[1].valueOf(),
    }
    props.setParams(dateTime)
  } else {
    dateParams.value = []
  }
}
const handlePromotionTypeChange=val=>{
  props.setParams({
    promotionType:val.target.value
  })
}
const onCalendarChange = val => {
  dates.value = val
}
const onOpenChange = open => {
  if (open) {
    dates.value = []
    hackValue.value = []
  } else {
    hackValue.value = undefined
  }
}

const columns = [
    {
      title: 'Primary Id',
      dataIndex: 'primaryTrackingIds',
      width: 200,
      fixed: 'left',
    },
    {
      title: 'Sub Id',
      dataIndex: 'subTrackingId',
      width: 200,
      fixed: 'left',
    },

  {
    title: 'DPVs',
    dataIndex: 'detailPageViews',
    width: 80,
    sorter: true,
  },
  {
    title: 'Add to Cart',
    dataIndex: 'addToCart',
    width: 130,
    sorter: true,
  },
  {
    title: 'Conversions',
    dataIndex: 'conversions',
    width: 120,
    sorter: true,
  },
  // {
  //   name: 'conversionsRate',
  //   title: 'Conversions Rate',
  //   dataIndex: 'conversionsRate',
  //   width: 180,
  //   sorter: true,
  // },
  {
    title: 'Sales for Commission',
    dataIndex: 'discountedSalesAmount',
    name: 'showCurrency',
    width: 240,
    sorter: true,
  },
  {
    title: 'Commission',
    dataIndex: 'commissionAmount',
    name: 'showCurrency',
    width: 120,
    sorter: true,
  }
];
</script>

<style lang="less" scoped>
:deep(.indent-level-1) {
  padding-left: 0 !important;
}
.filterBar{
  padding: 0px !important;
  margin-bottom: 16px !important;
}
.filterBar {
  display: flex;
  padding: 0px;
  margin-bottom: 16px;
  .filterBar-content {
    padding: 16px;
    background-color: var(--bg-gray-1);
    width: 100%;
    display: flex;
    justify-content: flex-start;
    border-radius: 8px;
  }
}
.marketplace,
.date,
.product,
// .brand,
.trankingId {
  display: flex;
  flex-direction: column;

  >span {
    color: var(--dark-2);
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.3px;
    line-height: 18px;
    margin-bottom: 4px;
  }
}
.radio{
  display: flex;
  align-items: center;
}
.brand{
  display: flex;
  align-items: center;
  >span {
    color: var(--dark-2);
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.3px;
    line-height: 18px;
    // margin-bottom: 4px;
  }
  
}
.sp-head-content,.brand-head-content {
    .text {
      margin-left: 8px;
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: center;
      > p {
        max-width: 1050px;
        font-weight: 600;
        font-size: 16px;
        color: var(--dark-1);
        letter-spacing: 0.5px;
        line-height: 22px;
        white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
      }
      span {
        padding: 4px 8px;
        border-radius: 6px;
        box-sizing: border-box;
        background: var(--bg-gray-8);

        font-weight: 500;
        font-size: 12px;
        color: var(--dark-2);
        letter-spacing: 0.3px;
        line-height: 16px;
        margin-top: 8px;
      }
    }
  }
.publisher-head-content,
  .brand-head-content,
  .sp-head-content {
    padding: 8px;
    display: flex;
    border-radius: 8px;
    align-items: center;
    margin-bottom: 16px;
    box-shadow: var(--disabled-box-shadow-5);
    > img {
      height: 72px;
      flex: 0 0 72px;
      max-width: 72px;
      position: relative;
      border-radius: 8px;
      object-fit: contain;
    }
    > span {
      width: 72px;
      height: 72px;
      min-width: 72px;
      line-height: 72px;
      text-align: center;
      position: relative;
      border-radius: 8px;
      background: var(--bg-gray-2);
      display: flex;
      align-items: center;
    }
    .flex {
      gap: 20px;
      display: flex;
    }
  }
.table {
  // :deep(.ant-table) {
  //   table {
  //     table-layout: fixed !important;
  //   }
  // }
}
.brand-name {
  margin: 0 auto;
  padding: 0 4px;
  max-width: 56px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 39px;
  font-weight: 600;
  line-height: 13px;
  text-align: center;
  color: var(--dark-4);
  letter-spacing: 0.3px;
  word-break: break-all !important;
}
</style> 